import { BillType } from "../../../api/services";

export const formatBillType = (type: BillType) => {
  switch (type) {
    case "Hot":
      return "Hot Bill";
    case "NewVersion":
      return "New Version";
    case "Manual":
      return "Manual Bill";
    case "CreditNote":
      return "Credit Note";
    default:
      return type;
  }
};
